import { createStatusOptions } from '@/config/statusOptions';

// An activity's `activity_type` — the category string iscc-backend derives from its log type.

export const ACTIVITY_MODULE = Object.freeze({
  accountSetup: 'Account setup',
  adminCentre: 'Admin center',
  inbounds: 'Inbounds',
  outbounds: 'Outbounds',
  suppliers: 'Manage suppliers',
  customers: 'Manage customers',
  operations: 'Operations',
  production: 'Production',
  other: 'Other',
});

// Suppliers and customers are one "Network" chip in the design.
export const ACTIVITY_MODULE_LABEL_KEYS = Object.freeze({
  [ACTIVITY_MODULE.accountSetup]: 'ACTIVITY_MODULE_ACCOUNT_SETUP',
  [ACTIVITY_MODULE.adminCentre]: 'ACTIVITY_MODULE_ADMIN_CENTRE',
  [ACTIVITY_MODULE.inbounds]: 'ACTIVITY_MODULE_INBOUNDS',
  [ACTIVITY_MODULE.outbounds]: 'ACTIVITY_MODULE_OUTBOUNDS',
  [ACTIVITY_MODULE.suppliers]: 'ACTIVITY_MODULE_NETWORK',
  [ACTIVITY_MODULE.customers]: 'ACTIVITY_MODULE_NETWORK',
  [ACTIVITY_MODULE.operations]: 'ACTIVITY_MODULE_OPERATIONS',
  [ACTIVITY_MODULE.production]: 'ACTIVITY_MODULE_PRODUCTION',
  [ACTIVITY_MODULE.other]: 'ACTIVITY_MODULE_OTHER',
});

export const {
  statusLabel: activityModuleLabel,
  buildStatusVariants: buildActivityModuleVariants,
} = createStatusOptions(ACTIVITY_MODULE_LABEL_KEYS);

// Filter option → the `activityFilters.module` values it sends.
// TODO: Monitor chip to be added later — no activity category exists for it server-side.
export const ACTIVITY_MODULE_FILTERS = Object.freeze({
  accountSetup: {
    labelKey: 'ACTIVITY_MODULE_ACCOUNT_SETUP',
    modules: [ACTIVITY_MODULE.accountSetup],
  },
  adminCentre: { labelKey: 'ACTIVITY_MODULE_ADMIN_CENTRE', modules: [ACTIVITY_MODULE.adminCentre] },
  inbounds: { labelKey: 'ACTIVITY_MODULE_INBOUNDS', modules: [ACTIVITY_MODULE.inbounds] },
  outbounds: { labelKey: 'ACTIVITY_MODULE_OUTBOUNDS', modules: [ACTIVITY_MODULE.outbounds] },
  network: {
    labelKey: 'ACTIVITY_MODULE_NETWORK',
    modules: [ACTIVITY_MODULE.suppliers, ACTIVITY_MODULE.customers],
  },
});

export const buildActivityModuleFilterOptions = (t) =>
  Object.entries(ACTIVITY_MODULE_FILTERS).map(([value, { labelKey }]) => ({
    value,
    label: t(labelKey),
  }));

export const toActivityModules = (selected = []) =>
  selected.flatMap((value) => ACTIVITY_MODULE_FILTERS[value]?.modules ?? []);
